var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-wrapper',[(_vm.title)?_c('vs-heading',{attrs:{"type":"subhead"}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('picture',[_vm._l((_vm.uiOptions.sources),function(source){return _c('source',{key:source.media,attrs:{"media":source.media,"srcset":source.srcset}})}),_c('img',{style:({
        height: _vm.uiOptions.height,
        maxWidth: _vm.uiOptions.maxWidth,
        maxHeight: _vm.uiOptions.maxHeight,
        width: _vm.uiOptions.width,
      }),attrs:{"src":_vm.uiOptions.src}})],2),(_vm.description)?_c('div',{staticClass:"hint"},[_c('vs-text',{attrs:{"type":"subdued"}},[_vm._v(_vm._s(_vm.description))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }